export const locale = {
  lang: 'de',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'Führungen laden',
        'TEX_FILT_INFO':'Führende filtern',
        'TEX_TITL_TAB1':'Führer auswählen',
        'TEX_TITL_TAB2':'Vorschau ausgewählter Leiter',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*Auswahl der anzuwendenden Führer',
        'TEX_INDIC_BUSQ':'Name, E-Mail oder Bereich eingeben',
        'TEX_BTN_FILT':'Filter',
        'TH_1':'Name des Leiters',
        'TH_2':'Mail',
        'TH_3':'Gebiet',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO-Benutzerstatus',
        'TH_EMA_LOCA':'Ortschaft',
        'TH_EMA_SEND':'Mails gesendet',
        'TH_PUEST_LEAD':'Post',
        'STATUS_LOGIN_CGO':{
        'false':'Inaktiv',
        'true':'Aktiv',
        'undefined':'Inaktiv',
        },
        'MODAL_ACTU_BAN_UNI':'Ausgewählten Anführer hinzufügen',
        'MODAL_ACTU_BAN_MUL':'Ausgewählten Anführer hinzufügen',
        'WARNI_NO_SELEC':'Kann den Schritt noch nicht abschließen, da noch kein Anführer ausgewählt wurde',
        'COMFI_COMP_PAS':'Sind Sie sicher, dass Sie den Schritt der Leiterauswahl abgeschlossen haben?',
        'BTN_CONFI_OK':'OK',
        'BTN_CONFI_YES':'Ja',
        'BTN_CONFI_NO':'Nein',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> Um Einladungs-E-Mails zu versenden, geben Sie den roten Code in das Textfeld ',
        'MSN_INGR_COD2':'</span>',
        'MODAL_CONFI_SEND_MAIL':'Sind Sie sicher, dass die E-Mails gesendet werden sollen?',
        'MODAL_CONFI_ACTIV_USER_CGO':'Sind Sie sicher, dass Sie den Benutzer aktivieren wollen?',
        'MODAL_CONFI_DESACTIV_USER_CGO':'Sind Sie sicher, dass Sie den Benutzer deaktivieren wollen?',
        'MSN_INGR_COD_ACTI_USER':'<span> Um den Benutzer zu aktivieren/deaktivieren, geben Sie den Code in roter Schrift in das Textfeld ein.  ',
        'MODAL_ERR_COD':'Der platzierte Text stimmt nicht überein',
        'WARNI_NO_SELEC_LEA':'Um E-Mails versenden zu können, wählen Sie mindestens einen Vorspann',
        'BTN_SEND_MAIL':'Mails senden',
        'BTN_CONFI_CONFIRMAR':'Bestätigen',
        'BTN_CONFI_CANCELAR':'Abbrechen',
        'MOD_INFO_SEN_EMA':'Versenden von E-Mails...',
        'SUCCE_SEN_EMA':'Sie wurden korrekt versendet',
        'NO_LEAD_PRODUCT_ASO':'Das zugehörige Zertifikat für dieses Produkt enthält keine Bleiverwender.',
        'MOD_ACTI_USE_CGO':'Aktualisierung des Benutzerstatus',
        'SUCCE_UPDA_STA_USE':'Erfolgreich aktualisiert',

      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'Sind Sie sicher, dass Sie den Schritt des Mail-Editors abgeschlossen haben? ',
        'FECHAS':{
          'TITULO':'Daten auswählen',
        'BTN_TEXT':'Termine auswählen',
        'INSTRUC_TEXT':'Wählen und registrieren Sie die verschiedenen Daten, die zur Konfiguration zur Verfügung stehen',
        },
        'CORREOS':{
          'TITULO':'Kommunikationsmeldungen',
        'BTN_TEXT':'Kommunikationsnachrichten anzeigen',
        'INSTRUC_TEXT':'Überprüfen Sie die zu sendenden Kommunikationsnachrichten',
          'TIPOS_CORREO':{
            'TIPO1_INVITA':{
              'TITULO': 'Einladungsnachricht',
              'DESCRIP': 'Dies ist die Nachricht, die am Tag des Starts des Aufrufs an die Leiter gesendet wird',
            },
            'TIPO2_RECOR_NO_INI':{
              'TITULO': 'Nachricht an die Leiter, die noch nicht gestartet sind',
              'DESCRIP':'Dies ist die Erinnerungsnachricht, die an die Leiter gesendet wird, die noch nicht begonnen haben',
            },
            'TIPO3_RECOR_NO_FINA':{
              'TITULO':'Nachricht an die Leiter, die noch nicht fertig sind',
              'DESCRIP':'Dies ist die Erinnerungsnachricht an die Leiter, die ihre Umfrage bereits begonnen, aber noch nicht beendet haben',
            },
          }
    },
        'MODAL_ACCIO':{
          'TIPO_ACCIO_FECH':{
            'TITU_TEXT1':'Wählen Sie jedes der verfügbaren Daten aus, um es zu konfigurieren',
        }
      },
      'ETIQ':{
        'tag_name':'Der Name des Führers',
          'tag_codeCoupon':'Der Coupon-Code',
          'tag_productoId':'Die Produkt-ID',
          'tag_nameCourse':'Der Name des Kurses',
      }
    },
      'TIP_EMAI': {
        'lanzamiento': 'Einladungsstartdatum',
        'aviso1': 'Pre-release (Erste Aufforderung vor dem Start der Umfrage)',
        'aviso2': 'Vorveröffentlichung (Zweite Aufforderung vor dem Start der Umfrage)',
        'cierre': 'Abschlussdatum',
        'recordatorio1': 'Datum des Versands der Erinnerung an diejenigen, die noch nicht gestartet sind',
        'recordatorio2': 'Datum, an dem die Erinnerung an diejenigen gesendet wird, die die Umfrage noch nicht beendet haben',
      },
      'SECCION_CONFIRM':{
        'BTN_CONFIRM_ENVIO':'Mailing bestätigen',
        'BTN_ENVIO_CONFIRM':'Das Mailing wurde bestätigt',
        'MODAL_COMPL_CONF':'Sind Sie sicher, dass Sie den Schritt der Versandbestätigung abgeschlossen haben?',
        'MODAL_WARNIN_CONF':'Um den Schritt abzuschließen, müssen Sie den Versand der Mails bestätigen.',
      },
      'SECCI_AVANCE':{
        'CARDS':{
          'PASO_1':{
            'TITULO':'Beförderung',
          'DESCRIP':'Aufstieg des Leiters',
          'BTN_1':'Gehe zum Zählportal',
          'BTN_2':'ZÄHLEN',
          },
          'PASO_2':{
            'TITULO':'Erinnerung',
          'DESCRIP':'Erinnerung an Führungskräfte, die den Prozess noch nicht begonnen oder beendet haben',
          'BTN_1':'Erinnerung',
          'BTN_2':'',
          }
        }
      },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'Name',
          'email':'Mail',
          'Area':'Bereich',
          'JobTitle':'Beitrag',
          'Localidad':'Standort',
          'NumberOfEmails':'Gesendete Post',
          'Age':'Jahr',
          'Gneration':'Geschlecht',
          'IdUser':'Benutzer-ID',
          'SurveyID':'Umfrage-ID',
          'keyUserlogin':'Passwort',
          'Pass_cgo':'Passwort',
      }
    }
  }
};
